/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import * as types from '../types';

const innitialState = () => {
  if (window.localStorage.getItem('theraytekjwt')) {
    return true;
  } else {
    return false;
  }
};
const loginned = (state = innitialState(), action) => {
  switch (action.type) {
    case types.user.LOGIN:
      return true;
    /* case types.user.LOGOUT:
      return false; */
    default:
      return state;
  }
};

export default loginned;
